/*
 * Quotes (draft 3, pipeline merged in on 2026-10-28, reworked 2026-10-29 from the old Steward and Jobber, List and
 * Pipeline views 2026-11-03): the top cards (quotes by status, then the past 30 days next to the 30 before), the pipeline
 * of leads by stage (each column scrolls and has its own settings), the quote list, the quote builder (Jobber's client picker and New client box so the browser
 * fills the address, the auto quoter, add-ons, a deposit, how long it is good for), and one quote's page.
 */
// What the quote screens share: the status tag and look, day helpers, the views.
import { QUOTE_STATUS_WORDS, type QuoteStatus } from "@steward/shared";
import { type Status, StatusLabel } from "../../components/parts";

const QUOTE_LOOK: Record<QuoteStatus, Status> = {
  draft: "inactive",
  sent: "warning",
  approved: "success",
  converted: "informative",
  declined: "critical",
  expired: "inactive",
};

export const QuoteTag = ({ status }: { status: QuoteStatus }) => (
  <StatusLabel status={QUOTE_LOOK[status]}>{QUOTE_STATUS_WORDS[status]}</StatusLabel>
);

export const DAY = 86_400_000;

/** A stored time as the day it was here (not in London), for shortDate. */
export const localDay = (iso: string) => new Date(iso).toLocaleDateString("en-CA");

export const sourceWords = (s: string | null) => (s ? s.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase()) : null);

/** The views of the Quotes page (/quotes?view=pipeline). Plan offers (2026-11-04) are the plan offer texts' links. */
export type QuotesView = "pipeline" | "list" | "offers";
